import {environment} from "./../../environments/environment";
export var srv_url: string = environment.HTTP_BASE_URL;
export var kyungnamIsTrue : boolean = environment.kyungnamIsTrue;
export var nambuIsTrue : boolean  = environment.nambuIsTrue;
export var dtaqIsTrue : boolean = environment.dtaqIsTrue;
//export var srv_url: string = "https://www.extrus.net:19446/exafe_admin";



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/service/global_url.ts